import { NgModule } from '@angular/core';
import { LibInfoFilledIconComponent } from './lib-info-filled-icon.component';

@NgModule({
  declarations: [LibInfoFilledIconComponent],
  exports: [LibInfoFilledIconComponent],
})
export class LibInfoFilledIconModule {}
